export default "__VITE_ASSET__CiyGjGSy__"